import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Col, message, Row, Spin } from "antd";

import edit from "../../../../../Assets/Images/edit.svg";
import chapters from "../../../../../Assets/Images/chapters.svg";
import deleteIcon from "../../../../../Assets/Images/delete.svg";

import * as ChaptersActions from "../../../../../Redux/Actions/ChaptersActions";

import "./ChapterDetail.scss";

const ChapterDetail = ({
  match,
  chapterDetail,
  getChapterDetails,
  deleteChapter,
  loading,
  history,
}) => {
  const chapterId = match.params.chapterId;
  const user = JSON.parse(localStorage.getItem("userdata"));

  /**
   * fetches chapter details when the component mounts.
   * @description - It sends a request to 'getChapterDetails' with the 'chapterId' and user's ID.
   */
  useEffect(() => {
    let data = {
      chapter_id: chapterId,
    };
    getChapterDetails(data, user?.id);
  }, []);

  /**
   * Function to delete a chapter. It sets the 'delete' flag to true and sends a request to 'deleteChapter'.
   * Upon successful deletion, it displays a success message and redirects to the chapter list.
   */
  const onDeleteChapter = () => {
    let data = {
      chapter_id: chapterId,
      delete: true,
    };
    deleteChapter(data, user?.id)
      .then(() => {
        message.success("Deleted");
        history.push({
          pathname: `/education/learn-investing/chapters`,
          state: { searchPlaceholder: "Search Chapter", back: true },
        });
      })
      .catch((e) => {
        message.error(e || "Failed to delete");
      });
  };

  return (
    <div className="chapter-preview-container">
      <div className="preview-header">
        <h6>Chapter</h6>
        <div className="header-right">
          <p
            onClick={() =>
              history.push(
                `/education/learn-investing/chapter-edit/${chapterId}`
              )
            }
          >
            <img src={edit} alt="add" />
            <span>Edit</span>
          </p>
          <p onClick={() => onDeleteChapter()}>
            <img src={deleteIcon} alt="add" />
            <span>Delete</span>
          </p>
        </div>
      </div>
      <div className="chapter-preview-wrap">
        {loading ? (
          <Spin />
        ) : (
          <Row gutter={16}>
            <Col span={4}>
              {chapterDetail?.header_image ? (
                <div className="header-image-wrap">
                  <img src={chapterDetail?.header_image} alt="header" />
                </div>
              ) : (
                <div className="header-default-wrap">
                  <img src={chapters} alt="header" />
                </div>
              )}
            </Col>
            <Col span={16} offset={2} className="content-wrap">
              <h2>{chapterDetail?.title}</h2>
              <p className="subtitle">{chapterDetail?.subtitle}</p>
              <div
                className="content"
                dangerouslySetInnerHTML={{ __html: chapterDetail?.content }}
              />
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.Chapter.loading,
    chapterDetail: state.Chapter.chapterDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getChapterDetails: (data, id) =>
      dispatch(ChaptersActions.getLearnSeriesChapterDetails(data, id)),
    deleteChapter: (data, id) =>
      dispatch(ChaptersActions.deleteChapter(data, id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChapterDetail);
